import { MicrofrontendContext } from '@cian/mf-react-legacy';
import { IBrowserMicrofrontend } from '@cian/mf-registry-legacy/browser';
import * as React from 'react';
import { hydrateRoot } from 'react-dom/client';

import { Application } from '../../../shared/containers/Application';
import { IApplicationContext } from '../../../shared/types/application';
import { TReduxStore } from '../../../shared/types/redux';

interface IDependencies {
  store: TReduxStore;
  context: IApplicationContext;
  microfrontend: IBrowserMicrofrontend;
}

export function renderApplication(dependencies: IDependencies) {
  const { store, microfrontend, context } = dependencies;

  const projectName = context.config.getStrict<string>('projectName');

  const rootElement = document.getElementById(projectName);

  if (!rootElement) {
    throw new Error(`Unable to find element #${projectName}`);
  }

  hydrateRoot(
    rootElement,
    <MicrofrontendContext.Provider value={microfrontend}>
      <Application context={context} reduxStore={store} />
    </MicrofrontendContext.Provider>,
  );
}
